import { OcpsStoreState } from '../store/schema/OcpsPolicyStore';
import getOcpsPolicyStoreState from '../selectors/getOcpsPolicyStoreState';
import { shouldRetryFetchPoliciesAndSetStore } from './shouldRetryFetchPoliciesAndSetStore';
import { logUsage } from 'owa-analytics';

export default function isOcpsStoreReady(): boolean {
    const storeState = getOcpsPolicyStoreState();
    const isStoreReady =
        storeState === OcpsStoreState.Ready || storeState === OcpsStoreState.FailedRetry;

    if (storeState === OcpsStoreState.FailedRetry) {
        shouldRetryFetchPoliciesAndSetStore();

        /* eslint-disable-next-line owa-custom-rules/telemetry-mailboxinfo-as-second-param -- (https://aka.ms/OWALintWiki)
         * BASELINE: DO NOT COPY/PASTE!
         *	> Argument at index 1 for logUsage must be of type MailboxInfo and not undefined. Telemetry calls that violate this rule will eventually be removed by the framework team. https://aka.ms/owa-analytics-mailboxinfo */
        logUsage('OcpsStoreFetchRetry', undefined);
    }

    return isStoreReady;
}
